import {Avatar} from 'antd'
import {course_getStudentById_Api} from 'apis'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {BsInfoCircleFill} from 'react-icons/bs'
import {FaUserGraduate, FaUserTie} from 'react-icons/fa6'
import {Link} from 'react-router-dom'
import {PiCertificate} from 'react-icons/pi'
import {getResponseItem, renderIf, renderIfElse} from '../../../../Shared'
import {IdentityVerificationSection} from './StudentIdentitySection'
import {IdentifierTypes} from '../../../appFieldTypes'
import getAvatar from "../../../../../helpers/getAvatar";
import getTitle from "../../../../../helpers/getTitle";
import ImageLoader from "../../../../../components/ImageLoader";
import {Photo} from "../../../../../conts/imageBase64";
import getLabelOfGender from "../../../../../helpers/getLabelOfGender";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {EstimatedDobTag} from 'components/common/EstimatedDobTag'
import getLinkToDetail from "../../../../../helpers/getLinkToDetail";
import {bindQueryParam} from "../../../functions/routerHelper";
import useAsync from "../../../../../modules/asyncCache/useAsync";
import {getId} from "../../../../../apis/model/base";
import getAliasName from "../../../../../helpers/getAliasName";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";
import {convertStringToDate} from "../../../../../helpers/dateUtils";
import {formatDate} from "../../../../../helpers/datetimeHelpers";
import classNames from "classnames";
import Toggle from "../../../../../components/Toggle";
import {IoChevronDownOutline} from "react-icons/io5";
import {HiOutlineLink} from "react-icons/hi2";

const ItemInformationStudent = ({label, value, primary = false}) => {
    const t = useTranslate()
    return (
        <div className="flex flex-col">
            <span className="text-xs text-color-400 tracking-wider">
                {t(label)}
            </span>
            <span
                className={classNames("text-sm break-words tracking-wide", primary === true ? 'font-bold text-color-000' : 'font-semibold text-gray-800')}>
                {value}
            </span>
        </div>
    )
}

export const StudentInformationFull = ({student, medal_awards = []}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const apiInfo = course_getStudentById_Api

    const id = getId(student) || student

    const {response, isLoading = false, handleAsyncAction: refresh} = useAsync({
        apiInfo,
        query: bindQueryParam({id}),
    })

    const item = getResponseItem(response)

    const {
        avatar,
        notes,
        edit,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        place_of_birth,
        patron_saint,
        patron_saint_name,
        fullname,
        contact_address,
        gender, date_of_birth, date_of_birth_is_estimated,
        contact_phone,
        contact_email,
        religious_order,
        religious_order_name,
        parish,
        parish_name,
        diocese,
        diocese_name,
    } = item ?? {}

    const typeIdentify = _.find(IdentifierTypes, {value: identifier_type})?.label
    // BE lưu NULL thật khi học viên chưa có ngày sinh (không bịa giá trị giả) - chỉ cần check rỗng.
    const isUnknownDob = !date_of_birth

    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col items-center gap-2">
                <Avatar
                    size={isLg ? 100 : 80}
                    src={avatar}
                    icon={<FaUserGraduate size={40} className="text-color-500"/>}
                    className="background-200 flex-shrink-0"
                />
                <span className="text-center font-bold text-base text-color-000 tracking-wide">
                    {`${getAliasName(item, 'patron_saint') || ''} ${fullname}`}
                </span>
            </div>

            <Toggle>
                {(isToggle, toggle) => (
                    <div className="flex flex-col border border-color-100 rounded-2xl">
                        <div className="p-3 flex items-center gap-2 border-b border-color-100">
                            <BsInfoCircleFill size={16} className="text-blue-400 flex-shrink-0"/>
                            <span
                                onClick={() => toggle()}
                                className={classNames(
                                    "flex-1 text-sm tracking-wide transition-all duration-300",
                                    isToggle ? 'font-semibold text-blue-600' : 'font-semibold text-gray-700 hover:text-gray-800'
                                )}>
                                {t('student information')}
                            </span>
                            <IoChevronDownOutline
                                onClick={() => toggle()}
                                size={14}
                                className={classNames(
                                    "flex-shrink-0 cursor-pointer transition-all duration-300",
                                    isToggle ? 'rotate-180 text-blue-600' : 'text-gray-700 hover:text-gray-800'
                                )}
                            />
                        </div>
                        <div className="p-3 flex flex-col items-center gap-3">
                            <div className="w-full flex flex-col gap-2">
                                <span className="font-bold text-2xs text-slate-400 uppercase tracking-wider">
                                    {t('basic info')}
                                </span>
                                <div className="ml-2 grid grid-cols-2 gap-3">
                                    <ItemInformationStudent primary={true} label="full name"
                                                            value={`${getAliasName(item, 'patron_saint') || ''} ${fullname}`}/>
                                    {(edit === true && identifier_code) && (
                                        <ItemInformationStudent label={t(typeIdentify)} value={identifier_code}/>
                                    )}
                                    {identifier_code && (
                                        <ItemInformationStudent label={t('student code')} value={student_idcode}/>
                                    )}
                                    {gender !== 0 && (
                                        <ItemInformationStudent label="gender" value={t(getLabelOfGender(gender))}/>
                                    )}
                                    {!isUnknownDob && (
                                        <ItemInformationStudent
                                            label="date of birth"
                                            value={
                                                <span className="flex items-center gap-1">
                                                    {convertStringToDate(date_of_birth).format('DD/MM/YYYY')}
                                                    {date_of_birth_is_estimated && <EstimatedDobTag/>}
                                                </span>
                                            }
                                        />
                                    )}
                                    {place_of_birth && (
                                        <ItemInformationStudent label="place of birth" value={place_of_birth}/>
                                    )}
                                    {renderIf(
                                        notes,
                                        <ItemInformationStudent label="note" value={notes}/>
                                    )}
                                </div>
                            </div>
                            {isToggle && (
                                <div className="w-full flex flex-col gap-2">
                                    <span className="font-bold text-2xs text-slate-400 uppercase tracking-wider">
                                        {t('contact information')}
                                    </span>
                                    <div className="ml-2 grid grid-cols-2 gap-3">
                                        {renderIf(
                                            _.some([parish_name, diocese_name]),
                                            <DoubleValueItem
                                                showIcon={true}
                                                labelFirst="belong to parish"
                                                valueFirst={parish_name}
                                                labelSecond={diocese_name && " - " || ''}
                                                valueSecond={diocese?.fullname}
                                                className="italic tracking-wider"
                                            />
                                        )}
                                        {religious_order_name && (
                                            <ItemInformationStudent
                                                label="belong to religious order"
                                                value={
                                                    <Link to={getLinkToDetail(religious_order)}
                                                          className="no-underline">
                                                        {religious_order_name}
                                                    </Link>
                                                }
                                            />
                                        )}
                                        {contact_phone && (
                                            <ItemInformationStudent label="phone" value={contact_phone}/>
                                        )}
                                        {contact_email && (
                                            <ItemInformationStudent label="email" value={contact_email}/>
                                        )}
                                        {contact_address && (
                                            <ItemInformationStudent abel="address" value={contact_address}/>
                                        )}
                                        {user && (
                                            <div className="flex flex-col gap-1">
                                                <span className="text-xs text-color-400 tracking-wider">
                                                    {t('link account')}
                                                </span>
                                                <div className="flex items-center gap-3">
                                                    <Avatar
                                                        size={26}
                                                        src={getAvatar(user)}
                                                        icon={<FaUserTie size={16} className="text-color-500"/>}
                                                        className="flex flex-center background-200"
                                                    />
                                                    {renderIfElse(
                                                        edit === true,
                                                        <Link
                                                            target="_blank" to={getLinkToDetail(user)}
                                                            className="font-medium text-color-000 no-underline leading-snug">
                                                            {getAliasName(user, 'patron_saint')}
                                                            {` ${getTitle(user)}`}
                                                            <HiOutlineLink size={12} className="ml-1 text-primary-600"/>
                                                        </Link>,
                                                        <span className="font-medium text-color-000 leading-snug">
                                                            {getAliasName(user, 'patron_saint')}
                                                            {getTitle(user)}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </Toggle>

            {/* Identity Verification Section */}
            {item && (
                <IdentityVerificationSection
                    item={item}
                    onRefresh={refresh}
                />
            )}

            {renderIf(
                medal_awards?.length > 0,
                <div className="flex flex-col gap-3">
                    <div className="flex items-center gap-2 pb-1.5 border-b border-color-50">
                        <PiCertificate size={13} className="text-color-400 flex-shrink-0"/>
                        <span className="text-xs font-semibold uppercase tracking-widest text-color-400">
                            {t('certification awarded')}
                        </span>
                    </div>
                    <div className="ml-2 flex flex-col gap-1">
                        {medal_awards.map((e, i) => (
                            <div key={i} className="w-full flex items-center gap-x-3 border border-color-50 rounded-md">
                                {renderIfElse(
                                    e?.medal?.avatar,
                                    <ImageLoader
                                        style={{width: 80, height: 55}}
                                        src={e?.medal?.avatar}
                                        fallback={Photo}
                                        className="rounded-l-md object-cover"
                                    />,
                                    <div style={{width: 80, height: 55}}
                                         className="flex flex-center background-100 rounded-l-md">
                                        <PiCertificate size={40} style={{color: '#dddddd'}}/>
                                    </div>
                                )}
                                <div className="flex flex-col flex-1 min-w-0 gap-1">
                  <span className="font-bold text-sm text-primary leading-tight">
                    {getTitle(e.medal)}
                  </span>
                                    <span className="flex items-center gap-1 text-xs italic leading-tight">
                    <span className="text-color-500">{`${t('date of award')} : `}</span>
                    <span
                        className="font-bold text-color-100">{formatDate(e?.medal?.eff_date, 'DD/MM/YYYY')}</span>
                  </span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}
